import { Typography } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

import { useAuth } from '../../../../../shared/providers/AuthProvider';

type MessageInfo = {
    authorName?: string;
    authorId?: string;
    sendDate?: Date;
};

type SharedByTextProps = {
    messageInfo?: MessageInfo;
};

export const SharedByText = ({ messageInfo }: SharedByTextProps) => {
    const { userId } = useAuth();
    const { formatMessage, formatDate } = useIntl();

    if (!messageInfo?.sendDate) return null;

    const formattedDate = formatDate(messageInfo.sendDate, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });
    const isSharedByMe = String(messageInfo.authorId) === String(userId);
    const sharedByAuthor = isSharedByMe
        ? formatMessage({ id: 'discussion.attachments_list.you' })
        : (messageInfo.authorName ?? null);

    return (
        <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }}>
            {sharedByAuthor
                ? formatMessage(
                      { id: 'discussion.attachments_list.shared_by_with_author' },
                      { author: sharedByAuthor, date: formattedDate },
                  )
                : formatMessage(
                      { id: 'discussion.attachments_list.shared_by_date_only' },
                      { date: formattedDate },
                  )}
        </Typography>
    );
};
